// extracted by mini-css-extract-plugin
export default {"cardView":"CardView_cardView__p5jRa"};